import * as React from "react";

import { ScrollToProvider, useScrollTo } from "../../Internals/Contexts/ScrollToContext";

import * as styles from "./FixedTabs.styles";
import { useFixedTabsContext } from "./FixedTabsContext";

interface FixedTabProps {
    id: string;
    "data-tid"?: string;
    title: React.ReactNode;
    children: React.ReactNode;
}

export function FixedTab(props: FixedTabProps): JSX.Element {
    const scrollTo = useScrollTo();
    const fixedTabsContext = useFixedTabsContext();

    React.useEffect(() => fixedTabsContext.register(props.id, () => props.title), [props.id]);

    const handleChildRequestScroll = React.useCallback(
        (el: Element) => {
            fixedTabsContext.setCurrentTab(props.id);
            scrollTo(el);
        },
        [props.id]
    );

    return (
        <ScrollToProvider value={handleChildRequestScroll}>
            <div
                data-tid={props["data-tid"] ?? props.id}
                css={styles.fixedTab(fixedTabsContext.currentId === props.id)}>
                {props.children}
            </div>
        </ScrollToProvider>
    );
}
